export const MOOD_SOUNDS = {
  sad: "/sounds/rain.mp3",
  focused: "/sounds/focus.mp3",
  energetic: "/sounds/energy.mp3",
};
